import { IFaq } from '@/study-search/interfaces';
import getters from '@/study-search/store/getters';
import { Filter } from '../filter';
import { FilterFacets } from '@/study-search/domain';
import { FaqFacetsHandler } from './FaqFacetsHandler';

export class DefaultFaqHandler extends FaqFacetsHandler {
	dataStorageKey = 'faqs/default';

	protected canHandle(): boolean {
		return true;
	}

	protected async handle(): Promise<IFaq[]> {
		const searchPageUrl = this.getSearchPageOnlineProgrammesUrl();

		let onlineProgrammeCount: number, percentageOfOnlineStudies: string;
		const data = this.getFromDataStorage();

		if (!data) {
			const noFilterFacets = await this.getFacetsForFilterCombination();

			onlineProgrammeCount = this.getOnlineProgrammeCount(noFilterFacets);
			percentageOfOnlineStudies = this.getPercentageOfOnlineStudies(noFilterFacets, onlineProgrammeCount);

			this.storeOnlineProgrammeData({ onlineProgrammeCount, percentageOfOnlineStudies });
		} else {
			onlineProgrammeCount = data.onlineProgrammeCount;
			percentageOfOnlineStudies = data.percentageOfOnlineStudies;
		}

		return [
			{
				question: `Can I get a Master's degree online?`,
				answer: `<div>Yes, you can. There are <a href="${searchPageUrl}">${onlineProgrammeCount} online Master’s available on Studyportals</a>,
				representing ${percentageOfOnlineStudies}% of the total.</div>`,
			},
			{
				question: `Is a Master's a graduate degree?`,
				answer: `<div>The short answer is yes, a Master’s is a graduate degree.
				The longer answer is that <b>any</b> academic degree beyond a Bachelor’s is a graduate degree.
				The term ‘graduate degree’ is most used in Canada and the USA, 
				while other English-speaking countries use the term ‘postgraduate’ instead when referring to the same thing.</div>`,
			},
			{
				question: `Can you get a Master's degree without a Bachelor's degree?`,
				answer: `<div>Rarely. If some Master’s programmes do allow getting in without a Bachelor’s,
				they are tailored for exceptionally talented students who have substantial relevant work experience.</div>`,
			},
			{
				question: `Which Master's Degree is Most in Demand?`,
				answer: `<div>The top 7 disciplines that spark student interest the most in the last 12 months, 
				according to Studyportals data are Management Studies, Computer Sciences, Business Administration, Data Science & Big Data,
				General Engineering & Technology, Health Sciences, and International Business. </div>`,
			},
		];
	}

	protected async getFacetsForFilterCombination(): Promise<FilterFacets[]> {
		const filters = getters.getFilters();

		const filtersCopy = filters.map((_) => ({ ..._ })) as Filter[];
		filtersCopy.forEach((_) => (_.values = []));

		const parameters = this.parameterService.getParameters(filtersCopy);

		const facetsResult = await this.getFacets(parameters);

		return facetsResult;
	}
}
